// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import DashboardHome from "../../components/dashboard/DashboardHome";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <DashboardHome />
    </DashboardLayout>
  );
}
